import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap'
import { InputType } from 'reactstrap/lib/Input'

interface IStringListEditorProps {
  addLabel?: string
  className?: string
  name?: string
  value: List<string>
  onChange: (newValue: List<string>) => void
  style?: React.CSSProperties
  type?: InputType
}

export default class StringListEditor extends React.PureComponent<
  IStringListEditorProps
> {
  constructor(props: IStringListEditorProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <div className={this.props.className} style={this.props.style}>
        <div className='mb-2'>
          <Button color='primary' outline onClick={this._addItem} size='sm'>
            {this.props.addLabel || 'Add Item'}
          </Button>
        </div>
        {this.props.value.toArray().map((val, i) => (
          <InputGroup key={`item-${i}`} className='mb-2'>
            <Input
              type={this.props.type || 'text'}
              name={
                this.props.name ? `${this.props.name}${i + 1}Text` : undefined
              }
              onChange={(e) => this._changeItem(i, e.target.value)}
              value={val}
              required
            />
            <InputGroupAddon addonType='append'>
              <Button
                color='danger'
                onClick={() => this._deleteItem(i)}
                outline
                title='Delete'
              >
                <FontAwesomeIcon icon={['fal', 'trash']} fixedWidth />
              </Button>
            </InputGroupAddon>
          </InputGroup>
        ))}
      </div>
    )
  }

  private _addItem() {
    this.props.onChange(this.props.value.push(''))
  }

  private _changeItem(index: number, newValue: string) {
    this.props.onChange(this.props.value.set(index, newValue))
  }

  private _deleteItem(index: number) {
    this.props.onChange(this.props.value.delete(index))
  }
}
